module.exports = __webpack_public_path__ + "static/media/item_27_1.d912260b.png";